// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32GFO","colBig":"styles_colBig__1Kcui","colSmall":"styles_colSmall__1g8FP","shopifyNameWrapper":"styles_shopifyNameWrapper__3jdK0"};